// DeckSideBar/ArrangementParameters.jsx
import React from 'react';
import './ArrangementParameters.css';

const ArrangementParameters = ({ 
  arrangeParameters = {
    startCorner: 0,
    arrangementDirection: "x",
    rowDirection: true,
    arrangementOptions: 0
  }, 
  setArrangeParameters 
}) => {
  const handleStartCornerChange = (corner) => {
    if (setArrangeParameters) {
      setArrangeParameters(prev => ({
        ...prev,
        startCorner: corner
      }));
    }
  };

  const handleArrangementDirectionChange = (direction) => {
    if (setArrangeParameters) {
      setArrangeParameters(prev => ({
        ...prev,
        arrangementDirection: direction
      }));
    }
  };

  const handleRowDirectionChange = (direction) => {
    if (setArrangeParameters) {
      setArrangeParameters(prev => ({
        ...prev,
        rowDirection: direction
      }));
    }
  };

  return (
    <div className="arrangement-container">
      <div className="cargo-area-section">
        <div className="arrangement-header">
          <h3> Arrangement parameters</h3> 
        </div>

        {/* Start Corner Section */}
        <div className="arrangement-section">
          <div className="corner-selection">
            <div className="corner-grid">
              <div className="arrangement-row">
                <button
                  className={`corner-btn corner-btn-modern ${arrangeParameters.startCorner === 0 ? 'active' : ''}`}
                  onClick={() => handleStartCornerChange(0)}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M4 4h16M4 4v16" strokeWidth="2"/>
                    <circle cx="6" cy="6" r="1.5" fill="currentColor"/>
                  </svg>
                </button>
                <button
                  className={`corner-btn corner-btn-modern ${arrangeParameters.startCorner === 1 ? 'active' : ''}`}
                  onClick={() => handleStartCornerChange(1)}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M4 4h16M20 4v16" strokeWidth="2"/>
                    <circle cx="18" cy="6" r="1.5" fill="currentColor"/>
                  </svg>
                </button>
              </div>
              <div className="arrangement-row">
                <button
                  className={`corner-btn corner-btn-modern ${arrangeParameters.startCorner === 3 ? 'active' : ''}`}
                  onClick={() => handleStartCornerChange(3)}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M4 4v16M4 20h16" strokeWidth="2"/>
                    <circle cx="6" cy="18" r="1.5" fill="currentColor"/>
                  </svg>
                </button>
                <button
                  className={`corner-btn corner-btn-modern ${arrangeParameters.startCorner === 2 ? 'active' : ''}`}
                  onClick={() => handleStartCornerChange(2)}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M20 4v16M4 20h16" strokeWidth="2"/>
                    <circle cx="18" cy="18" r="1.5" fill="currentColor"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Arrangement Direction Section */}
          <div className="direction-options">
            <div className="direction-conteiner">
              <div className="direction-variants">
                <div className="direction-left-right">
                  <button
                    className={`corner-btn corner-btn-modern ${arrangeParameters.arrangementDirection === "x" ? 'active' : ''}`}
                    onClick={() => handleArrangementDirectionChange("x")}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M20 12H4" strokeWidth="2"/>
                      <path d="M8 8l-4 4 4 4" strokeWidth="2"/>
                    </svg> 
                  </button>
                  <button
                    className={`corner-btn corner-btn-modern ${arrangeParameters.arrangementDirection === "y" ? 'active' : ''}`}
                    onClick={() => handleArrangementDirectionChange("y")}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M4 12H20" strokeWidth="2"/>
                      <path d="M16 8l4 4-4 4" strokeWidth="2"/>
                    </svg>
                  </button>
                </div>

                <div className="direction-tier-row">
                  <button
                    className={`big-icon-btn big-icon-btn-modern ${arrangeParameters.rowDirection === true ? 'active' : ''}`}
                    onClick={() => handleRowDirectionChange(true)}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0" y="14" width="8" height="8" fill="currentColor" fillOpacity="0.9"/>
                      <rect x="8" y="14" width="8" height="8" fill="currentColor" fillOpacity="0.8"/>
                      <rect x="16" y="14" width="8" height="8" fill="currentColor" fillOpacity="0.7"/>
                      
                      <rect x="0" y="6" width="8" height="8" fill="currentColor" fillOpacity="0.7"/>
                      <rect x="8" y="6" width="8" height="8" fill="currentColor" fillOpacity="0.9"/>
                    </svg>
                  </button>
                  <button
                    className={`big-icon-btn big-icon-btn-modern ${arrangeParameters.rowDirection === false ? 'active' : ''}`}
                    onClick={() => handleRowDirectionChange(false)}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.8 14.4L7.2 10.8L12.6 14.4L7.2 18L1.8 14.4Z" fill="currentColor" fillOpacity="0.9"/>
                      <path d="M7.2 10.8L12.6 7.2L18 10.8L12.6 14.4L7.2 10.8Z" fill="currentColor" fillOpacity="0.8"/>
                      <path d="M12.6 7.2L18 3.6L23.4 7.2L18 10.8L12.6 7.2Z" fill="currentColor" fillOpacity="0.7"/>
                      
                      <path d="M7.2 18L12.6 14.4L18 18L12.6 21.6L7.2 18Z" fill="currentColor" fillOpacity="0.9"/>
                      <path d="M12.6 14.4L18 10.8L23.4 14.4L18 18L12.6 14.4Z" fill="currentColor" fillOpacity="0.8"/>
                    </svg>                    
                  </button>
                </div>
              </div> 
            </div>  
          </div> 
        </div>
      </div>
    </div>
  );
};

export default ArrangementParameters;